var render, staticRenderFns
import script from "./HelpPlaceForm.vue?vue&type=script&lang=js"
export * from "./HelpPlaceForm.vue?vue&type=script&lang=js"
import style0 from "./HelpPlaceForm.vue?vue&type=style&index=0&id=1b9014d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports